module.exports = __webpack_public_path__ + "img/RJ.66f126c6.png";